<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">康养行业</div>
                <div class="minTitle">通过智能化的照护体系，利用先进的评估模型为长者建立个性化照护服务方案。以自研的软硬件利用科技和数据为核心建立以长者为中心的7*24小时全天候服务机制。通过智能化软件相结合为养老行业建立统一的服务调度平台。提高养老行业资源调度能力和服务管理效率。打造具备实时，智能，精细，可视，多维的行业智能化服务平台，助力养老行业数字化转型。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
       <picture>
            <source srcset="@/assets/images/ky1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/ky1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">方案特点</div>

                <div class="items mt5 pc-list">
                    <div class="item2">
                        <img src="@/assets/images/ky2.png" />
                        <div class="lb">
                            <div class="minTitle2">一体化软硬件整合</div>
                            <div class="minTitle2">各种功能无缝连接，更贴近机构管理</div>
                        </div>
                    </div>
                    <div class="item2">
                        <img src="@/assets/images/ky3.png" />
                        <div class="lb">
                            <div class="minTitle2">标准化的业务管理</div>
                            <div class="minTitle2">多达20多个量表贯穿整个业务过程</div>
                        </div>
                    </div>
                    <div class="item2 item3">
                        <img src="@/assets/images/ky4.png" />
                        <div class="lb">
                            <div class="minTitle2">模块化设计</div>
                            <div class="minTitle2">根据实际管理深度适配最合适的模块</div>
                        </div>
                    </div>
                </div>
                <div class="items mt5 mb-list">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/ky2.png" />
                            <div class="lb">
                                一体化软硬件整合
                            </div>
                        </div>
                        <div class="minTitle2 mt10">各种功能无缝连接，更贴近机构管理</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/ky3.png" />
                            <div class="lb">
                                标准化的业务管理
                            </div>
                        </div>
                        <div class="minTitle2 mt10">多达20多个量表贯穿整个业务过程</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/ky4.png" />
                            <div class="lb">
                                模块化设计
                             </div>
                        </div>
                        <div class="minTitle2 mt10">根据实际管理深度适配最合适的模块</div>
                    </div>
                </div>
                <div class="ibr">
                    <div class="title1 tc mt20">产品</div>
                    <div class="mt20 bg4">
                        <img src="@/assets/images/ky5.png" />
                    </div>
                </div>
                
            </div>
       </div>
       <div class="conBg">
            <div class="content">
                <div class="items pc-car">
                    <div class="item2">
                        <img src="@/assets/images/ky9.png" />
                        <div class="myTitle">养老机构</div>
                        <div class="pd15">
                            <div class="minTitle2 hs">7*24小时的全天候智能服务机制</div>
                            <div class="minTitle2">结合自研、智能硬件、传感器技术、数据可视化，在充分保护隐私的前提下实现24小时无间断的实时监控及报警处理，充分保护长者的安全。</div>
                            <div class="minTitle2 hs">业务流程科学标准规范化：</div>
                            <div class="minTitle2">通过先进的业务系统规范入住办理、护理服务、费用缴费、退住办理等流程，简化了业务管理，操作更加简单易用。</div>
                            <div class="minTitle2 hs">运营管理流程智能化：</div>
                            <div class="minTitle2">业务流程能够自动运行流转，数据管理实现智能化，提升养老机构运营管理效率。</div>
                            <div class="minTitle2 hs">运营数据可视化：</div>
                            <div class="minTitle2">老人信息、护理服务、费用账单、安全报警等数据，能实现可视化管理和分析，为运营提供数据支撑。</div>
                            <div class="minTitle2 hs">护理服务流程完整化：</div>
                            <div class="minTitle2">基于先进的量表确定护理等级、制定护理计划、护理任务执行及记录、护理情况监督及推送的完整业务流程体系。</div>
                        </div>
                    </div>
                    <div class="item2">
                        <img src="@/assets/images/ky8.png" />
                        <div class="myTitle">养老公寓</div>
                        <div class="pd15">
                            <div class="minTitle2 hs">AI健康检查与评估：</div>
                            <div class="minTitle2">基于先进的监控检测设备和评估系统进行健康综合评估并生成个性化的健康评估报告并入住老人制定健康管理服务计划，细化为实操化的健康和生活服务指南，比如：营养膳食计划、运动康复计划、心理支持、疾病预防和管理、药物管理、风险防控计划等。</div>
                            <div class="minTitle2 hs">运营数据可视化：</div>
                            <div class="minTitle2">老人信息、护理服务、费用账单、安全报警等数据，能实现可视化监控及分析，为业务管理提供数据支撑。</div>
                            <div class="minTitle2 hs">护理服务流程完整化：</div>
                            <div class="minTitle2">基于先进的量表确定护理等级、制定护理计划、护理任务执行及记录、护理情况监督及推送的完整业务流程体系。</div>
                        </div>
                    </div>
                    <div class="item2 item3">
                        <img src="@/assets/images/ky7.png" />
                        <div class="myTitle">家庭床位</div>
                        <div class="pd15">
                            <div class="minTitle2 hs">适老化改造：</div>
                            <div class="minTitle2">对有需求的老人将提供专业的服务团队对长者身体和居住环境进行评估并制定适老化改造方案。</div>
                            <div class="minTitle2 hs">智能安全服务：</div>
                            <div class="minTitle2">结合自研智能硬件、传感器技术、数据可视化，在充分保护隐私的前提下实现24小时无间断的实时监控及报警处理，充分保护长者的安全。</div>
                            <div class="minTitle2 hs">健康监控实时掌握：</div>
                            <div class="minTitle2">通过先进的评估量表和体征监测硬件建立老人电子健康档案形成专的监控分析报告，对多种基本进行实时监控，并生成相应的护理方案。</div>
                            <div class="minTitle2 hs">服务工单质量监管：</div>
                            <div class="minTitle2">家庭养老床位解决方案对工单的高效执行，对服务质量的有效监管。</div>
                            <div class="minTitle2 hs">运营数据可视化：</div>
                            <div class="minTitle2">老人信息、护理服务、费用账单、安全报警等数据，能实现可视化监控及分析，为业务管理提供数据支撑。</div>
                        </div>
                    </div>
                </div>
                <div class="items mb-car">
                    <el-carousel arrow="never" :height="flashHeight" ref="carousel" :autoplay="false">
                        <el-carousel-item>
                            <div class="img">
                                <img src="@/assets/images/ky9.png" />
                                <div class="myTitle">养老机构</div>
                            </div>
                            <div class="con">
                                <div class="p">
                                    <h3>7*24小时的全天候智能服务机制</h3>
                                    <p>结合自研、智能硬件、传感器技术、数据可视化，在充分保护隐私的前提下实现24小时无间断的实时监控及报警处理，充分保护长者的安全。</p>
                                </div>
                                <div class="p">
                                    <h3>业务流程科学标准规范化：</h3>
                                    <p>通过先进的业务系统规范入住办理、护理服务、费用缴费、退住办理等流程，简化了业务管理，操作更加简单易用。</p>
                                </div>
                                <div class="p">
                                    <h3>运营管理流程智能化：</h3>
                                    <p>业务流程能够自动运行流转，数据管理实现智能化，提升养老机构运营管理效率。</p>
                                </div>
                                <div class="p">
                                    <h3>运营数据可视化：</h3>
                                    <p>老人信息、护理服务、费用账单、安全报警等数据，能实现可视化管理和分析，为运营提供数据支撑。</p>
                                </div>
                                <div class="p">
                                    <h3>护理服务流程完整化：</h3>
                                    <p>基于先进的量表确定护理等级、制定护理计划、护理任务执行及记录、护理情况监督及推送的完整业务流程体系。</p>
                                </div>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="img">
                                <img src="@/assets/images/ky8.png" />
                                <div class="myTitle">养老公寓</div>
                            </div>
                            <div class="con">
                                <div class="p">
                                    <h3>AI健康检查与评估：</h3>
                                    <p>基于先进的监控检测设备和评估系统进行健康综合评估并生成个性化的健康评估报告并入住老人制定健康管理服务计划，细化为实操化的健康和生活服务指南，比如：营养膳食计划、运动康复计划、心理支持、疾病预防和管理、药物管理、风险防控计划等。</p>
                                </div>
                                <div class="p">
                                    <h3>运营数据可视化：</h3>
                                    <p>老人信息、护理服务、费用账单、安全报警等数据，能实现可视化监控及分析，为业务管理提供数据支撑。</p>
                                </div>
                                <div class="p">
                                    <h3>护理服务流程完整化：</h3>
                                    <p>基于先进的量表确定护理等级、制定护理计划、护理任务执行及记录、护理情况监督及推送的完整业务流程体系。</p>
                                </div>
                            </div>
                        </el-carousel-item>
                        <el-carousel-item>
                            <div class="img">
                                <img src="@/assets/images/ky7.png" />
                                <div class="myTitle">家庭床位</div>
                            </div>
                            <div class="con">
                                <div class="p">
                                    <h3>适老化改造：</h3>
                                    <p>对有需求的老人将提供专业的服务团队对长者身体和居住环境进行评估并制定适老化改造方案。</p>
                                </div>
                                <div class="p">
                                    <h3>智能安全服务：</h3>
                                    <p>结合自研智能硬件、传感器技术、数据可视化，在充分保护隐私的前提下实现24小时无间断的实时监控及报警处理，充分保护长者的安全。</p>
                                </div>
                                <div class="p">
                                    <h3>健康监控实时掌握：</h3>
                                    <p>通过先进的评估量表和体征监测硬件建立老人电子健康档案形成专的监控分析报告，对多种基本进行实时监控，并生成相应的护理方案。</p>
                                </div>
                                <div class="p">
                                    <h3>服务工单质量监管：</h3>
                                    <p>家庭养老床位解决方案对工单的高效执行，对服务质量的有效监管。</p>
                                </div>
                                <div class="p">
                                    <h3>运营数据可视化：</h3>
                                    <p>老人信息、护理服务、费用账单、安全报警等数据，能实现可视化监控及分析，为业务管理提供数据支撑。</p>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui'
    export default {
        components: {
            [Carousel.name]: Carousel,
            [CarouselItem.name]: CarouselItem
        },
        data() {
            return {
                windowWidth: '', //获取屏幕宽度
                flashHeight: '720px',  // flash高度
            }
        },
        methods: {
            loadFlashImg() {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
                var that = this
                window.onresize = () => {
                    return (() => {
                        that.windowWidth = that.$refs.index.offsetWidth //获取屏幕宽度
                    })()
                }
            },
            startAuto() {
                var that = this
                if(that.autoplay == false){
                    that.autoplay = true;
                }
            },
            stopAuto() {
                var that = this
                if(that.autoplay == true){
                    that.autoplay = false;
                }
            },
            slideBanner1() {
                var that = this
                var box = document.querySelector('.mb-car .el-carousel__container');
                var startPoint = 0;
                var stopPoint = 0;
                
                var resetPoint =  function(){
                    startPoint = 0;
                    stopPoint = 0;
                }
                
                
                box.addEventListener("touchstart",function(e){
                    that.stopAuto();
                    startPoint = e.changedTouches[0].pageX;
                });
                
                box.addEventListener("touchmove",function(e){
                    stopPoint = e.changedTouches[0].pageX;
                });
                box.addEventListener("touchend",function(e){
                if(stopPoint == 0 || startPoint - stopPoint == 0){
                    resetPoint();
                        return;
                    }
                    if(startPoint - stopPoint > 0){
                        resetPoint();
                        that.$refs.carousel.next();
                        return;
                    }
                    if(startPoint - stopPoint < 0){
                        resetPoint();
                        that.$refs.carousel.prev();
                        return;
                    }
                });
            },
        },
        watch: {
            windowWidth (val) {
                this.flashHeight = (this.$refs.flashImg.height - 10)  + 'px'
            }
        },
        mounted() {
            this.slideBanner1()
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .conBg {
            background: url(../../assets/images/ky6.png) no-repeat;
            background-size: 100% 100%;
            min-height: 500px;
            padding: 90px 0 30px;
            .mb-car {
                display: none;
            }
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    width: 31.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    img {
                        width: 100%;
                        height: auto;
                        vertical-align: bottom;
                    }
                    .pd15 {
                        padding: 5px 15px 15px 15px;
                        .minTitle2 {
                            line-height: 17px;
                        }
                        .hs {
                            color: #333333;
                            margin-top: 10px;
                            margin-bottom: 4px;
                        }
                    }
                    .myTitle {
                        text-align: center;
                        height: 70px;
                        line-height: 70px;
                        margin-top: -70px;
                        font-size: 20px;
                        color: #ffffff;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
        
        .lxwm {
            padding: 30px 0;
            .mb-list {
                display: none !important;
            }
            .bg4 {
                background-color: #F0F7FD;
                padding: 25px;
                text-align: center;
                img {
                    width: 90%;
                    height: auto;
                }
            }
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    img {
                        width: 50px;
                        height: 44px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        vertical-align: bottom;
                        .minTitle2 {
                            color: #333333;
                            line-height: 20px;
                        }
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .conBg {
        background: none;
        min-height: unset;
        padding: 0;
        .content {
            padding: 0;
        }
        .pc-car {
            display: none;
        }
        .mb-car {
            display: block;
            /deep/ .el-carousel__button {
                background-color: #333;
            }
            .img {
                position: relative;
                img {
                    width: 100%;
                    height: auto;
                }
                .myTitle {
                    position: absolute;
                    color: #fff;
                    left: 10%;
                    bottom: 12%;
                    font-size: 18px;
                }
            }
            .con {
                padding: 0 25px;
                h3 {
                    margin: 10px 0;
                    font-size: 16px;
                    font-weight: normal;
                }
                p {
                    margin-bottom: 15px;
                }
            }
        }
    }
    .lxwm {
        .title1 {
            margin-bottom: 0;
            margin-top: 0;
        }
        .myTitle {
            font-size: 14px;
            background: none;
        }
        .pc-list {
            display: none;
        }
        .mb-list {
            display: block !important;
        }
       
        .ibr {
            .mt20.bg4 {
                margin: 0;
                padding: 0;
            }
            .title1 {
                margin: 30px 0;
            }
            .bg4 img {
                width: 100%;
            }
        }
        .items {
            .ibr {
                .mt20.bg4 {
                    margin: 0;
                    padding: 0;
                }
            }
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 15px 15px;
                min-height: 110px;
                box-sizing: border-box;
                .minTitle2 {
                    font-size: 14px;
                    text-align: center;
                    margin-top: 15px;
                }
                
                .lb {
                    line-height: normal;
                    font-size: 16px;
                }
                .tit {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: auto;
                        height: 20px;
                    }
                }
            }
        }
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
    }
}
</style>